import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent implements OnInit {

    @Input() isPaymentRefund = false;
    @Input() initiatedVoidCC = false;
    @Input() initiatedStripEMVPayment = false;
    @Input() showPaymentMessage = false;
    @Input() isReversal = false;
    @Input() isEmvAutopay = false;
    @Input() isManualAutopay = false;
    @Input() retryTransactionStatus = false;
    @Input() processingUnit = null;
    @Input() userRiskDelay = false;
    @Input() dlScanloaderRequest=false;
    @Input() isReportGeneration=false;
    @Input() isTDEmv = null;
    @Input() stripeLoader = null;
    @Output() emitPaymentTerminalStatus: EventEmitter<any> = new EventEmitter<any>();
    @Output() emitLedgerTerminalStatus: EventEmitter<any> = new EventEmitter<any>();
    private paymentMaxWaitTime = environment.paymentMaxWaitTime;
    timer : any;
    display = "00:00";
    isCancelledDisabled : boolean = false;

    constructor() { }

  ngOnInit(): void {
    if (this.initiatedStripEMVPayment || (this.isTDEmv && (this.isTDEmv.isPortClosingWaitTime || this.isTDEmv.isTransactionWaitTime || this.isTDEmv.isVoidTransactionWaitTime))) {
      this.display = "0" + this.paymentMaxWaitTime + ":00";
      let seconds: number = this.paymentMaxWaitTime * 60;
      let textSec: any = "0";
      let startSec: number = 60;
      const prefix = this.paymentMaxWaitTime < 10 ? "0" : "";
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(() => {
        seconds--;
        if (startSec != 0) {
          startSec--;
        } else {
          startSec = 59;
        }
        if (startSec < 10) {
          textSec = "0" + startSec;
        } else textSec = startSec;
        this.display = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
        if (seconds == 0) {
          clearInterval(this.timer);
        }
      }, 1000);
    }
    this.isCancelledDisabled = false;
  }

  onStatusClick(){
    if (this.stripeLoader?.isPyamnet) {
      this.emitPaymentTerminalStatus.emit('Status');
    } else {
      this.emitLedgerTerminalStatus.emit('Status');
    }
  }

  onCancelClick(){
    this.isCancelledDisabled = true;
    if (this.stripeLoader?.isPyamnet) {
      this.emitPaymentTerminalStatus.emit('Cancel');
    }else {
      this.emitLedgerTerminalStatus.emit('Cancel');
    }
  }
}
